import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Report {
  _id: string;
  type: string;
  title: string;
  htmlContent?: string;
  status: string;
  createdAt: string;
}

interface ReportState {
  reports: Report[];
  currentReport: Report | null;
  generating: boolean;
  downloading: boolean;
  error: string | null;
}

const initialState: ReportState = {
  reports: [],
  currentReport: null,
  generating: false,
  downloading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    generateReportRequest: (state, action: PayloadAction<{ type: string; analysisId: string; employeeId?: string }>) => {
      state.generating = true;
      state.error = null;
    },
    generateReportSuccess: (state, action: PayloadAction<Report>) => {
      state.generating = false;
      state.currentReport = action.payload;
      state.reports.push(action.payload);
    },
    generateReportFailure: (state, action: PayloadAction<string>) => {
      state.generating = false;
      state.error = action.payload;
    },
    downloadReportRequest: (state, action: PayloadAction<string>) => {
      state.downloading = true;
      state.error = null;
    },
    downloadReportSuccess: (state, action: PayloadAction<Report>) => {
      state.downloading = false;
      state.currentReport = action.payload;
    },
    downloadReportFailure: (state, action: PayloadAction<string>) => {
      state.downloading = false;
      state.error = action.payload;
    },
    fetchReportsRequest: (state, action: PayloadAction<string>) => {
      state.error = null;
    },
    fetchReportsSuccess: (state, action: PayloadAction<Report[]>) => {
      state.reports = action.payload;
    },
    fetchReportsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearCurrentReport: (state) => {
      state.currentReport = null;
    },
  },
});

export const {
  generateReportRequest,
  generateReportSuccess,
  generateReportFailure,
  downloadReportRequest,
  downloadReportSuccess,
  downloadReportFailure,
  fetchReportsRequest,
  fetchReportsSuccess,
  fetchReportsFailure,
  clearCurrentReport,
} = reportSlice.actions;

export default reportSlice.reducer;